// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1qbqR","text":"SelectPayment_text__p3jeE","title":"SelectPayment_title__2Q3kn","btn":"SelectPayment_btn__xpIBb"};